<template lang="pug">
.drop_zone(@drop='drop_handler', @dragleave="showDragFiles = false", @dragover.prevent="", @click="$emit('click')", v-if="showDragFiles")
  slot(name='dropzone')
    .dragdropfiles Drop your files here.
</template>
<script type="text/javascript">
export default {
  props: {
    addFileCallback: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      showDragFiles: false
    }
  },
  methods: {
    open () {
      this.showDragFiles = true
    },
    drop_handler (ev) {
      let traverseFile = (item, path) => {
        path = path || ''
        let entry = item
        if (entry.isFile) {
          item.file((f) => {
            f.fullPath = path + f.name
            this.addFileCallback(f)
          })
        } else if (entry.isDirectory) {
          var dirReader = entry.createReader()
          dirReader.readEntries((entries) => {
            entries.forEach((dirEntry) => {
              traverseFile(dirEntry, path + entry.name + '/')
              // traverseFileTree(entries[i], path + item.name + "/");
            })
          })
        }
      }
      ev.preventDefault()
      this.showDragFiles = false
      // If dropped items aren't files, reject them
      var dt = ev.dataTransfer
      if (dt.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < dt.items.length; i++) {
          if (dt.items[i].kind === 'file') {
            traverseFile(dt.items[i].webkitGetAsEntry())
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < dt.files.length; i++) {
          console.log('... file[' + i + '].name = ' + dt.files[i].name)
        }
      }
    }
  }
}
</script>
<style lang="sass">
.drop_zone
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0
  z-index: 99999
  background-color: rgba(255,255, 255, 0.5)
  text-align: center
  padding-top: 70px
  font-size: 2em
</style>



// WEBPACK FOOTER //
// Dropzone.vue?243ce31a